export const INITIAL = {
	VIEW: 'login',
	VALUES: {
		email: '',
		username: '',
		password: '',
		new_password: '',
		code: '',
	},
}